export enum DistanceType {
    Far = 1,
    Near = 2
}